<template>
  <div class="quickReplyConfiguration">
    <h4>快捷回复语设置</h4>
    <el-button type="primary" size="small" @click="addemp">新增快捷回复</el-button>


    <ul>
      <li v-for="(item, i) in list" :key="i">
        <div class="top_box">
          <h5>{{ item.paramTitle }}</h5>
          <div class="icon_box">
            <i class="el-icon-edit-outline" @click="edit(item)"></i>
            <i class="el-icon-delete-solid" @click="deleteShortcuts(item)"></i>
          </div>
        </div>
        <p>{{ item.paramValue }}</p>
      </li>

    </ul>


    <div class="hm-pagination" v-if="total > 10">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>




    <!-- 新增快捷回复 -->
    <el-dialog title="创建回复语" width="600px" :visible.sync="dialogTableVisible">
 
      <el-input v-model="paramTitle" clearable placeholder="请输入标题" show-word-limit maxlength="20" size="samll" style="width: 100%; margin-bottom:20px;"></el-input>

      <el-input
        type="textarea"
        :rows="4"
        clearable
        size="samll"
        show-word-limit
        maxlength="200"
        placeholder="请输入回复内容"
        v-model="paramValue">
      </el-input>


      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false" size="small" >取 消</el-button>
        <el-button type="primary" size="small" @click="submit">确 定</el-button>
      </span>
    </el-dialog>




  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      isEditAdd: false,
      paramTitle:'',
      paramValue:'',
      dialogTableVisible: false,
      currentPage: 1,
      pageSize: 10,
      list:[],
      row: '',
      total: 0
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryPageListQuickReplies();
  },
  mounted() {
  },
  methods: {
    deleteShortcuts(row){
       this.$store.dispatch('delQuickReplyById', { id: row.id }).then(res => {
        console.log(res);
        if(res.code == 0){
          this.$message.success('删除成功');
          this.queryPageListQuickReplies();
        }
      })
    },
    edit(row){
      console.log(row);
      this.row = row;
      this.isEditAdd = true;
      this.paramValue = row.paramValue;
      this.paramTitle = row.paramTitle;
      this.dialogTableVisible = true;
    },
    async submit(){
      let url  = 'storeQuickReplyInfoAdd';
      if(!this.paramTitle){
        this.$message.error('请输入标题');
        return;
      }
      if(!this.paramValue){
        this.$message.error('请输入回复语');
        return;
      }
      let params = {
        paramCode:'storeQuickReply',
        paramTitle: this.paramTitle,
        paramValue: this.paramValue
      };
    
      if(this.isEditAdd) {
        url = 'storeQuickReplyInfoEdit';
        params = {
          id: this.row.id,
          paramTitle: this.paramTitle,
          paramValue: this.paramValue
        }
      }
      await this.$store.dispatch(url, params);
      this.dialogTableVisible = false;
      this.queryPageListQuickReplies();
    },
    async queryPageListQuickReplies(){
     const { result } = await this.$store.dispatch('queryPageListQuickReplies', {
      pageNo: this.currentPage,
      pageSize: this.pageSize
     });
     this.total = result.total;
     this.list = result.records;
    },
    addemp(){
      this.dialogTableVisible = true;
      this.paramValue = '';
      this.paramTitle = '';
    },
    paging(page) {
      this.currentPage = page;
      this.queryPageListQuickReplies();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryPageListQuickReplies();
    },

  }
};
</script>
<style lang="scss" scoped>
.quickReplyConfiguration {
  width: 100%;
  height: calc(100vh - 100px);
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  h4 {
    margin-top: 0;
  }

  ul {
    margin-top: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    li {
      width: 300px;
      height: 100px;
      background: #f9fafb;
      border-radius: 10px;
      padding: 10px;
      margin-right: 10px;
      margin-bottom: 10px;
      .top_box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        h5 {
          margin: 0;
          font-size: 15px;
        }
        .icon_box {
          i {
            color: #8d95a0;
            margin-right: 10px;
            cursor: pointer;
          }
        }
      }
      p {
        font-size: 14px;
        line-height: 20px;
        color: #8d95a0;
      }
    }
  }
}

</style>
